
export const SPRITE_PATHS = {
  "default": "/_nuxt/nuxt-svg/sprite-default.BMkLRf9A6nlobUppeB47eJiPfpPOrV4LkQYt_eFyxJE.svg"
}
export const runtimeOptions = {"ariaHidden":false}
